// extracted by mini-css-extract-plugin
export default {"addressSection":"ZV-z","disabled":"_V-z","sectionButtons":"aW-z","logo":"bW-z"};